import React from "react";
import { useSelector } from "react-redux";
import HorizontalFeature from "./HorizontalFeature";
import GeocodeDescription from "../SideBar/Results/Geocoding/GeocodeDescription";
import "../DataGrid/DataGrid.css";

const HorizontalView = () => {
    const geocodeFeatures = useSelector(
        (state) => state.resultsData.geocodingData?.candidates
    );
    const resultsForFeature = useSelector((state) => state.resultsData.resultsForFeature);

    return (
        <>
            {resultsForFeature.length > 0 &&
            resultsForFeature[0].DisplayName !== "ArcGIS Geocoder" ? (
                <HorizontalFeature />
            ) : geocodeFeatures ? (
                <GeocodeDescription />
            ) : (
                <div />
            )}
        </>
    );
};

export default HorizontalView;
